import axios from "axios";
import { get as getCookie } from 'es-cookie';
import { authenticationConstants, alertConstants } from "../_constants";
import { push } from "react-router-redux";

export const clientWithoutCredentials = axios.create({
    baseURL: CONFIG.ApiSettings.url,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    }
});

export function clientWithCredentials(dispatch: any) {
    const client = axios.create({
        baseURL: CONFIG.ApiSettings.url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + getCookie("token")
        }
    })
    client.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if (error.message == "Network Error") {
            dispatch({
                type: alertConstants.ALERT_SHOW,
                notification: {
                    message: "netErr",
                    level: "error"
                }
            });
        }
        if (error.response.status == 401) {
            localStorage.removeItem("user");
            dispatch({
                type: authenticationConstants.AUTHENTICATION_LOGOUT
            });
            dispatch({
                type: alertConstants.ALERT_SHOW,
                notification: {
                    message: "logout",
                    level: "info"
                }
            });
            dispatch(push("/login"))
        }
        return Promise.reject(error);
    });

    return client;
}